import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import {
    statisticsScopeIsPending,
    statisticsScopeNotes,
    type StatisticsScopeText,
    type TableStatisticsScope,
} from 'app/modules/shared/utils/table-structure-statistics-scope';

/**
 * The caption that says which department set a structure's figures were measured over.
 *
 * It exists as its own component rather than as markup in each dialog because both dialogs that
 * render a structure are already the two largest files in this feature, and because the sentence
 * has to read identically in both: a member comparing the upload dialog with the metadata viewer
 * must not be told two different things about the same numbers.
 */
@Component({
    selector: 'app-structure-scope-note',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatIconModule, TranslocoModule],
    templateUrl: './structure-scope-note.component.html',
    styleUrl: './structure-scope-note.component.scss',
})
export class StructureScopeNoteComponent {
    notes: StatisticsScopeText[] = [];
    pending = false;

    private _scope: TableStatisticsScope | null = null;

    // Derived on write rather than read: OnPush re-evaluates a template getter on every check, and
    // the notes only change when the served structure does.
    @Input()
    set scope(value: TableStatisticsScope | null | undefined) {
        this._scope = value ?? null;
        this.notes = statisticsScopeNotes(this._scope);
        this.pending = statisticsScopeIsPending(this._scope);
    }

    get scope(): TableStatisticsScope | null {
        return this._scope;
    }

    trackByNote(_index: number, note: StatisticsScopeText): string {
        return note.key;
    }
}
